import {
  Inter100,
  Inter200,
  Inter300,
  InterRegular,
  Inter500,
  Inter600,
  Inter700,
  Inter800,
  Inter900,
} from './font-files';

export const fontFaces = `
@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 100;
  src: local(''),
       url(${Inter100}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 200;
  src: local(''),
       url(${Inter200}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  src: local(''),
       url(${Inter300}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  src: local(''),
       url(${InterRegular}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  src: local(''),
       url(${Inter500}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  src: local(''),
       url(${Inter600}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  src: local(''),
       url(${Inter700}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 800;
  src: local(''),
       url(${Inter800}) format('woff2');
}

@font-face {
  font-display: swap;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 900;
  src: local(''),
       url(${Inter900}) format('woff2');
}
`;
